import {Component, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, Renderer2} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SubSink} from 'subsink';
import {Title} from '@angular/platform-browser';
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {environment} from "../../../../../../environments/environment";

@Component({
  selector: 'bit-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  private sub = new SubSink();
  title!: string;
  content!: string;
  slug!: string;


  constructor(private route: ActivatedRoute, private titleService: Title, @Inject(PLATFORM_ID) private platformId: string,
              @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private router: Router,
              @Optional() @Inject('lang') private lang: string) {
  }

  ngOnInit(): void {
    this.sub.sink = this.route.data.subscribe((data) => {
      this.title = data.content.title;
      this.content = data.content.text;
      this.slug = data.content.slug;
      this.titleService.setTitle($localize`bit.ir | ${this.title}`)
    })
    if (this.document) {
      const canonical = this.document.querySelector('link[rel="canonical"]');
      if (canonical) {
        if (isPlatformBrowser(this.platformId)) {
          this.renderer.setAttribute(canonical, 'href', window.location.href);
        } else {
          this.renderer.setAttribute(canonical, 'href', environment.domain + this.lang );
        }
      }
    }
  }

  ngOnDestroy(): void {
  }

}
